import React from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import StyledTextarea from './styled'

const TextArea = (props) => {
  const {
    name,
    // 样式
    className,
    style,
    rows,
    // 值
    value,
    defaultValue,
    placeholder,
    // 状态
    disabled,
    readonly,
    autofocus,
    // 校验
    maxLength,
    minLength,
    // 事件
    onChange,
    onFocus,
    onBlur,
  } = props

  return (
    <StyledTextarea
      name={name}
      className={clsx('form-textarea', className)}
      style={style}
      rows={rows}
      value={value}
      defaultValue={defaultValue}
      placeholder={placeholder}
      readonly={readonly}
      disabled={disabled}
      autoFocus={autofocus}
      maxLength={maxLength}
      minLength={minLength}
      onChange={onChange}
      onBlur={onBlur}
      onFocus={onFocus}
    />
  )
}

TextArea.propTypes = {
  name: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.shape,
  rows: PropTypes.number,
  value: PropTypes.string,
  defaultValue: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  readonly: PropTypes.bool,
  autofocus: PropTypes.string,
  maxLength: PropTypes.number,
  minLength: PropTypes.number,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
}

TextArea.defaultProps = {
  name: undefined,
  className: undefined,
  style: undefined,
  rows: 3,
  value: undefined,
  defaultValue: undefined,
  placeholder: undefined,
  disabled: false,
  readonly: false,
  autofocus: undefined,
  maxLength: undefined,
  minLength: undefined,
  onChange: () => {},
  onFocus: () => {},
  onBlur: () => {},
}

export default TextArea
